import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51d4bfa6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-root" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, null, -1))
const _hoisted_4 = { class: "input-field user-name" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "input-field password" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "dp-value" }
const _hoisted_9 = {
  key: 0,
  class: "dp-list"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "input-field call"
}
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = { class: "input-capcha-group" }
const _hoisted_14 = { class: "input-field shield-check" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = { class: "capcha-image-wrap" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "agree-info" }
const _hoisted_19 = { class: "button-group" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "dropdown-content" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "check" }, null, -1))
const _hoisted_24 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_service = _resolveComponent("i-service")!
  const _component_i_user = _resolveComponent("i-user")!
  const _component_i_lock = _resolveComponent("i-lock")!
  const _component_i_layer = _resolveComponent("i-layer")!
  const _component_i_arrow_l = _resolveComponent("i-arrow-l")!
  const _component_i_call = _resolveComponent("i-call")!
  const _component_i_sheild_check = _resolveComponent("i-sheild-check")!
  const _component_i_reload = _resolveComponent("i-reload")!
  const _component_icon_arrow_down = _resolveComponent("icon-arrow-down")!
  const _component_marquee_text = _resolveComponent("marquee-text")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "customer-service",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.contactService && _ctx.contactService(...args)))
    }, [
      _createVNode(_component_i_service, {
        "fill-color": '#e0d77f',
        class: "icon"
      }),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.t('common.onlineservice')), 1)
    ]),
    _createElementVNode("form", {
      action: "",
      class: "form",
      onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.doLogin && _ctx.doLogin(...args)), ["prevent"]))
    }, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_i_user, { class: "icon" }),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.uname) = $event)),
          placeholder: _ctx.t('login.username')
        }, null, 8, _hoisted_5), [
          [_vModelText, _ctx.uname]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_i_lock, { class: "icon" }),
        _withDirectives(_createElementVNode("input", {
          type: "password",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pwd) = $event)),
          placeholder: _ctx.t('login.password')
        }, null, 8, _hoisted_7), [
          [_vModelText, _ctx.pwd]
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "input-field layer",
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.showLoginType = !_ctx.showLoginType), ["prevent"]))
      }, [
        _createVNode(_component_i_layer, { class: "icon" }),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.t(`login.${_ctx.loginType.name}`)), 1),
        _createVNode(_component_i_arrow_l, {
          class: _normalizeClass(["icon-arrow-l", { active: _ctx.showLoginType }])
        }, null, 8, ["class"]),
        _createVNode(_Transition, { name: "slide-down" }, {
          default: _withCtx(() => [
            (_ctx.showLoginType)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredLoginType, (_loginType) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: _loginType.id,
                      onClick: ($event: any) => (_ctx.onSelectLoginType(_loginType))
                    }, _toDisplayString(_ctx.t(`login.${_loginType.name}`)), 9, _hoisted_10))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])), [
        [_directive_click_outside, _ctx.hideShowLoginType]
      ]),
      (_ctx.loginType.id === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_i_call, { class: "icon" }),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.phoneNumber) = $event)),
              placeholder: _ctx.t('login.enterphonenumber')
            }, null, 8, _hoisted_12), [
              [_vModelText, _ctx.phoneNumber]
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_i_sheild_check, { class: "icon" }),
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.capchaInput) = $event)),
            placeholder: _ctx.t('login.verificationcode'),
            onKeydown: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onCapchaKeydown && _ctx.onCapchaKeydown(...args)))
          }, null, 40, _hoisted_15), [
            [_vModelText, _ctx.capchaInput]
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("img", { src: _ctx.capchaSrc }, null, 8, _hoisted_17)
          ]),
          _createVNode(_component_i_reload, {
            class: "reload",
            onClick: _ctx.getImage
          }, null, 8, ["onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", {
          class: _normalizeClass(["cirle-indicator", { 'active': _ctx.agreed }]),
          onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.agreed = !_ctx.agreed), ["prevent"]))
        }, null, 2),
        _createElementVNode("div", {
          class: "agree-info-label",
          onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showAgreeBox && _ctx.showAgreeBox(...args)), ["prevent"]))
        }, _toDisplayString(_ctx.t('login.useragreement')), 1)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("button", {
          type: "submit",
          class: "submit",
          disabled: !_ctx.agreed
        }, _toDisplayString(_ctx.t('login.login')), 9, _hoisted_20),
        _createElementVNode("button", {
          type: "button",
          class: "button",
          onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.doTrylogin && _ctx.doTrylogin(...args)), ["prevent"]))
        }, _toDisplayString(_ctx.t('login.guestlogin')), 1)
      ])
    ], 32),
    _createElementVNode("div", {
      class: _normalizeClass(["lang-options", [_ctx.lang, { show: _ctx.showLanguageOptions }]]),
      onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.showLanguageOptions = !_ctx.showLanguageOptions), ["self"]))
    }, [
      _createTextVNode(_toDisplayString(_ctx.language) + " ", 1),
      _createVNode(_component_icon_arrow_down),
      _createElementVNode("ul", _hoisted_21, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.langArr, (i) => {
          return (_openBlock(), _createElementBlock("li", {
            key: i.code,
            class: _normalizeClass([{ active: i.code === _ctx.lang }, i.code]),
            onClick: ($event: any) => (_ctx.selectLanguage(i.code))
          }, [
            _createTextVNode(_toDisplayString(i.name) + " ", 1),
            _hoisted_23
          ], 10, _hoisted_22))
        }), 128))
      ])
    ], 2),
    _createElementVNode("div", _hoisted_24, [
      _createVNode(_component_marquee_text, {
        class: "m-notice",
        speed: 30
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.ipvnotice), 1)
        ]),
        _: 1
      })
    ])
  ]))
}